(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-modal"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.querySelector('.page-modal-wrapper');
  const modal = wrapper?.querySelector('.page-modal');
  if (!wrapper || !modal) return;

  const isWrapperVisible = () => window.getComputedStyle(wrapper).display !== 'none';

  const lockBodyScroll = () => {
    if (document.body.classList.contains('modal-open')) return;

    const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.classList.add('modal-open');

    // évite le "shift" quand la scrollbar disparaît
    if (scrollBarWidth > 0) {
      document.body.style.paddingRight = scrollBarWidth + 'px';
    }
  };

  const unlockBodyScroll = () => {
    document.body.classList.remove('modal-open');
    document.body.style.paddingRight = '';
  };

  const closeModal = () => {
    wrapper.style.display = 'none';
    unlockBodyScroll();
  };

  // Si la modal est déjà ouverte au chargement
  if (isWrapperVisible()) lockBodyScroll();

  wrapper.addEventListener('click', (e) => {
    // close button/link
    const trigger = e.target.closest('a[href="#close-mobal"], button[href="#close-mobal"]');
    if (trigger) {
      e.preventDefault();
      closeModal();
      return;
    }

    // click overlay
    if (!modal.contains(e.target)) {
      closeModal();
    }
  });

  // ESC pour fermer
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isWrapperVisible()) {
      closeModal();
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
